/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdditionalInformationInner } from './additionalInformationInner';
import { SalesProduct } from './salesProduct';
import { Document } from './document';

/**
 * Returns all calculated prices.   The prices are embedded into the *salesProduct* object.   Further there are non-binding PDF documents, intended to be reviewed by the B2C customer.
 */
export interface GetOrderResponse {
  salesProduct?: SalesProduct;
  /**
   * Unique transaction number generated by Verti. In the subsequent and final TAA order requests, belonging to the same business transaction, this number must be provided in the request.   (bipro-gevo::Vorgangsnummer)
   */
  transactionNumber?: string;
  documents?: Array<Document>;
  /**
   * Additional information concerning the response.
   */
  additionalInformation?: Array<AdditionalInformationInner>;
}
